import __base_store from '@/store/__base_store'

/**
 * Store de vinculaciones de inventario (modelo `inventory_linkage`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'inventory_linkage',
	},
})

